import { render, staticRenderFns } from "./SubjectSelection.vue?vue&type=template&id=3c3933cd&"
import script from "./SubjectSelection.vue?vue&type=script&lang=js&"
export * from "./SubjectSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports